// @flow

import common from './locales/pt/common.json'

export const pt = { common }

export default pt
